var rmUtil = require("../rmlibrary_old/util");
var PDFCanvasNode = require("./canvas");
var _r = require;
var canvg = (function() {
    try {
        // eslint-disable-next-line no-undef
        return window.canvg;
    } catch (e) {
        // Do nothing
    }
    try {
        return _r("canvg");
    } catch (e) {
        // Do nothing
    }
})();

function outerHTML(node) {
    var tmpDiv = node.ownerDocument.createElement("div");
    var clone = node.cloneNode(true);
    tmpDiv.appendChild(clone);
    var outerHTML = tmpDiv.innerHTML;
    tmpDiv.innerHTML = "";
    return outerHTML;
}

function PDFSVGNode(node) {
    PDFCanvasNode.apply(this, arguments);

    this.generateFn = function(doc, cursor, canvas) {
        if (!canvg) {
            return;
        }

        var svgText = (node.outerHTML || outerHTML(node)).replace(/xmlns="http:\/\/www.w3.org\/2000\/svg"/, "");

        canvg(canvas, svgText, {
            ignoreMouse: true,
            ignoreAnimation: true,
            ignoreDimensions: true,
        });
    };
}
rmUtil.inherits(PDFSVGNode, PDFCanvasNode);

PDFSVGNode.prototype.getDataUri = function() {
    return "";
};

module.exports = PDFSVGNode;
